import { createAction } from '@reduxjs/toolkit'
import { ProjectSearchResponse } from '../api'
import { ProjectsSearchFilter } from '../reducers/states'

export const search = createAction<ProjectsSearchFilter>('PROJECTS_SEARCH_REQUEST')
export const receivedProjects = createAction<ProjectSearchResponse[]>('PROJECTS_SEARCH_RECEIVED')
export const searchErrorProjects = createAction<string>('PROJECTS_SEARCH_ERROR')
export const downloadProjectFile = createAction<string>('PROJECT_FILE_REQUEST')
